import { SegmentSchema } from '@sondermind/segment';

export interface IMatchflowSubmittedData {
  flow: string;
  in_person_test_group: boolean;
}

export interface IMatchFlowStepSubmitted {
  flow: string;
  step_name: string;
  in_person_test_group: boolean;
  answer: Record<string, string | number>;
}

export interface IMatchflowStartedData {
  flow: string;
  referral_source: string;
}

export enum FlowsHostSegmentEvents {
  MATCH_FLOW_SUBMITTED = 'Client Match Flow Submit Button Clicked',
  MATCH_FLOW_STEP_SUBMITTED = 'Client Match Flow Step Submitted',
  MATCH_FLOW_STARTED = 'Client Match Flow Started'
}

export interface IFlowsHostSegmentSchema extends SegmentSchema {
  [FlowsHostSegmentEvents.MATCH_FLOW_SUBMITTED]: IMatchflowSubmittedData;
  [FlowsHostSegmentEvents.MATCH_FLOW_STEP_SUBMITTED]: IMatchFlowStepSubmitted;
  [FlowsHostSegmentEvents.MATCH_FLOW_STARTED]: IMatchflowStartedData;
}
